module.exports = __webpack_public_path__ + "static/media/016.0c2ee8bd.jpg";